module.exports = __webpack_public_path__ + "img/trophy-pink.7bf4caec.svg";